// extracted by mini-css-extract-plugin
export default {"viewport":"GameLayout_viewport__+l4Uo","stage":"GameLayout_stage__g4R4J"};